import { ReportableItem } from "../@types/Posts";
import { findAll, storeReporting } from "../services/posts";

export default function usePost() {
  function all() {
    return findAll();
  }

  function doStoreReport(data: ReportableItem[]): Promise<boolean> {
    return storeReporting(data);
  }

  return {
    all,
    storeReport: doStoreReport,
  };
}
